<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title" *ngIf="header !== ''">{{ header }}</div>
    <div class="sopo-popup-text" *ngIf="body !== ''" [innerHTML]="body"></div>
    <div class="sopo-popup-input-container">
        <input
            class="sopo-popup-input"
            [placeholder]="placeholder"
            [pattern]="getPattern()"
            [autocomplete]="autocomplete"
            spellcheck="false"
            [type]="inputType"
            [formControl]="inputControl"
            (input)="validateInput($event)"
            (keyup.enter)="close()"/>
        @if (forNickName) {
            @for (validation of nickname_validations; track $index) {
                <div class="nickname-error" *ngIf="inputControl?.errors && inputControl?.errors[validation.type]">
                    {{ validation.message }}
                </div>
            }
        }
    </div>
    <div class="sopo-popup-button-container">
        <div [ngClass]="forNickName && !inputControl.valid ? 'sopo-popup-grey-button' : 'sopo-popup-green-button ion-activatable clickable'" (click)="close()">
            {{ okText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-white-button ion-activatable clickable" (click)="close(true)" *ngIf="cancelText !== ''">
            {{ cancelText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>
